import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "row row-eq-height"
}
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "col-md-9 album-holder" }
const _hoisted_8 = { class: "album-intro-card" }
const _hoisted_9 = { class: "album-title" }
const _hoisted_10 = { class: "album-name" }
const _hoisted_11 = {
  key: 0,
  class: "album-name-sub"
}
const _hoisted_12 = {
  key: 1,
  class: "album-name-sub"
}
const _hoisted_13 = { class: "album-year" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "style-list" }
const _hoisted_16 = { class: "style-list" }
const _hoisted_17 = { class: "heart-list" }
const _hoisted_18 = {
  key: 0,
  class: "hot-info-item"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fire text-gray" }, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "hot-info-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-read text-gray" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-heartfillmtui" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-heartbeat" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "album-rate-card"
}
const _hoisted_25 = { class: "row mt-3" }
const _hoisted_26 = { class: "col-lg-8" }
const _hoisted_27 = {
  key: 0,
  class: "bg-white p-3"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", null, "每日坚果推荐", -1)
const _hoisted_29 = { class: "bg-white p-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "曲目", -1)
const _hoisted_31 = { class: "tracklist" }
const _hoisted_32 = { class: "pos" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "duration" }
const _hoisted_35 = {
  key: 0,
  class: "credits"
}
const _hoisted_36 = {
  key: 1,
  class: "credits"
}
const _hoisted_37 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_38 = { class: "link-list info-box" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "info-box" }
const _hoisted_41 = { class: "info-box" }
const _hoisted_42 = { class: "info-box" }
const _hoisted_43 = {
  key: 0,
  class: "info-box"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "info-box mt-3"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h3", null, "评论区", -1)
const _hoisted_47 = { class: "col-lg-12" }
const _hoisted_48 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StyleTag = _resolveComponent("StyleTag")!
  const _component_ArticleListItem = _resolveComponent("ArticleListItem")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_CommentList = _resolveComponent("CommentList")!
  const _component_ElTabPane = _resolveComponent("ElTabPane")!
  const _component_ElTabs = _resolveComponent("ElTabs")!
  const _component_AlbumEdit = _resolveComponent("AlbumEdit")!
  const _component_AddToChartEditor = _resolveComponent("AddToChartEditor")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_wechat_title = _resolveDirective("wechat-title")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.info.primary_img)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.info.primary_img,
                    class: "img-fluid"
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "img-fluid",
                    src: "/static/naimage.jpg",
                    alt: _ctx.info.title
                  }, null, 8, _hoisted_6))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.artists, (artist) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: artist._id as string,
                        to: { path: '/meta/artist/' + artist._id },
                        class: "artist-name display-inline-block"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(artist.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.info.title), 1),
                  (_ctx.info.title_cn_simp)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "[" + _toDisplayString(_ctx.info.title_cn_simp) + "]", 1))
                    : (_ctx.info.title_roman)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "[" + _toDisplayString(_ctx.info.title_roman) + "]", 1))
                      : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_13, "[ " + _toDisplayString(_ctx.info.year) + " ]", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.online_links, (link, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "link-outside link-online"
                    }, [
                      _createElementVNode("a", {
                        href: link.url,
                        target: "_blank"
                      }, _toDisplayString(_ctx.online_link_name[index]), 9, _hoisted_14)
                    ]))
                  }), 128)),
                  (_ctx.info.type.index != 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["badge mr-3", {
                                    'badge-success': _ctx.info.type.index == 1,
                                    'badge-primary': _ctx.info.type.index != 1,
                                }])
                      }, _toDisplayString(_ctx.info.type.name), 3))
                    : _createCommentVNode("", true),
                  (_ctx.info.album_type.index != 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: _normalizeClass(["badge mr-3", {
                                    'badge-success': _ctx.info.album_type.index == 1,
                                    'badge-primary': _ctx.info.album_type.index != 1,
                                }])
                      }, _toDisplayString(_ctx.info.album_type.name), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.styles, (style) => {
                    return (_openBlock(), _createBlock(_component_StyleTag, {
                      key: style._id,
                      genre: style,
                      full: 0
                    }, null, 8, ["genre"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.relate_styles, (style) => {
                    return (_openBlock(), _createBlock(_component_StyleTag, {
                      key: style._id,
                      genre: style,
                      full: 0
                    }, null, 8, ["genre"]))
                  }), 128))
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_ctx.info.hot_index > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.info.hot_index), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.info.counter_view > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.info.counter_view), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: _normalizeClass(["hot-info-item", { active: _ctx.now_heart == 1 }]),
                    href: "javascript:void(0)",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doHeart(1)))
                  }, [
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.info.counter_heart_1), 1)
                  ], 2),
                  _createElementVNode("a", {
                    class: _normalizeClass(["hot-info-item", { active: _ctx.now_heart == 2 }]),
                    href: "javascript:void(0)",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doHeart(2)))
                  }, [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.info.counter_heart_2), 1)
                  ], 2)
                ])), [
                  [_directive_loading, _ctx.heart_loading]
                ])
              ]),
              (_ctx.info.rating_anon > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString((_ctx.info.rating_anon / 10).toFixed(1)), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.rocknuts.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rocknuts, (article_info) => {
                  return (_openBlock(), _createBlock(_component_ArticleListItem, {
                    key: article_info._id,
                    article: article_info,
                    full: 1,
                    position: "meta-album"
                  }, null, 8, ["article"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("ul", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info?.tracklist, (track, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: track.position,
                  class: "track"
                }, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(track.position || (index as number) + 1), 1),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(track.title), 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(track.duration), 1),
                  (track.artists)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(track.artists, (ca) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: ca.name
                          }, " [ " + _toDisplayString(ca.name) + " ] ", 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (track.extraartists)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(track.extraartists, (ca) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: ca.name
                          }, " [ " + _toDisplayString(ca.role) + ":" + _toDisplayString(ca.name) + " ] ", 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        (_ctx.info)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: "link-outside"
                  }, [
                    _createElementVNode("a", {
                      href: link.url,
                      target: "_blank"
                    }, _toDisplayString(link.site), 9, _hoisted_39)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_40, "数据品质：" + _toDisplayString((_ctx.info.quality as any).name), 1),
              _createElementVNode("div", _hoisted_41, [
                (_ctx.userInfo.type.index >= 1 && (_ctx.info.quality as any).index < 2)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success mr-3",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showEditer && _ctx.showEditer(...args)))
                    }, "编辑"))
                  : _createCommentVNode("", true),
                (_ctx.userInfo.type.index >= 1 && (_ctx.info.quality as any).index < 2)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success mr-3",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleShowThirdEditor && _ctx.handleShowThirdEditor(...args)))
                    }, "拉取Discogs/网易"))
                  : _createCommentVNode("", true),
                (_ctx.userInfo.type.index >= 2 && (_ctx.info.quality as any).index == 1)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doLockInfo && _ctx.doLockInfo(...args)))
                    }, "锁定"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createTextVNode(" 数据整理： "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.contribute_user, (user) => {
                  return (_openBlock(), _createBlock(_component_UserTag, {
                    key: user._id,
                    user: user,
                    full: 1
                  }, null, 8, ["user"]))
                }), 128))
              ]),
              (_ctx.userInfo.type.index >= 1 && _ctx.info)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    (_ctx.userInfo.type.index >= 1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn btn-outline-success mr-3",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handlerCreateArticle && _ctx.handlerCreateArticle(...args)))
                        }, "推荐每日坚果"))
                      : _createCommentVNode("", true),
                    (_ctx.albumCachedIndex == -1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "btn btn-outline-success mr-3",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handlerCacheAdd && _ctx.handlerCacheAdd(...args)))
                        }, "榜单缓存"))
                      : _createCommentVNode("", true),
                    (_ctx.albumCachedIndex > -1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: "javascript:void(0)",
                          class: "btn btn-outline-success mr-3",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handlerCacheRemove && _ctx.handlerCacheRemove(...args)))
                        }, "移除缓存"))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success mr-3",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handlerAddToRank && _ctx.handlerAddToRank(...args)))
                    }, "追加榜单")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.userInfo.userId && _ctx.info)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_CommentList, {
                      "target-type": "ALBUM",
                      "target-id": _ctx.id,
                      "comment-info": {
                                artist_id: _ctx.info.main_artist._id,
                                album_id: _ctx.id,
                            }
                    }, null, 8, ["target-id", "comment-info"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_ElTabs, {
            modelValue: _ctx.activeOnlineLink,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeOnlineLink) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info?.online_links, (link, index) => {
                return (_openBlock(), _createBlock(_component_ElTabPane, {
                  key: index,
                  label: _ctx.online_link_name[index],
                  name: index
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.activeOnlineLink != '')
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                style: {"border":"0"},
                frameborder: "0",
                width: "100%",
                height: "640px",
                src: _ctx.activeOnlineLinkUrl
              }, null, 8, _hoisted_48))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_AlbumEdit, {
        id: _ctx.id,
        ref: "albumEditor",
        visible: _ctx.dialogFormVisible,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
        onChange: _ctx.refreshData
      }, null, 8, ["id", "visible", "onChange"]),
      (_ctx.dialogAddRankFormVisible && _ctx.info)
        ? (_openBlock(), _createBlock(_component_AddToChartEditor, {
            key: 1,
            id: _ctx.id,
            visible: _ctx.dialogAddRankFormVisible,
            "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogAddRankFormVisible) = $event)),
            type: "album",
            album: _ctx.info,
            onChange: _ctx.refreshData
          }, null, 8, ["id", "visible", "album", "onChange"]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loadings.info]
    ])
  ])), [
    [_directive_wechat_title, 
            _ctx.info
                ? _ctx.info.main_artist_show +
                  ' - ' +
                  _ctx.info.title +
                  ' [' +
                  _ctx.info.year +
                  '] - ' +
                  _ctx.route.meta.title
                : undefined
        ]
  ])
}